export default __webpack_public_path__ + "static/media/etherscan.23dbf6ca.svg";